import { Label } from "@/components/atoms/texts/label";
import { Button } from "@/components/molecules/buttons/button";
import useDocxRequest from "./useDocxRequest";

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"
import { getEmojiFlag } from 'countries-list'
import { countries, languages } from 'countries-list'
import { useState } from "react";

import { Input } from "@/components/ui/input"
import { toast } from "@/components/organisms/feedback/use-toast";
import { Toaster } from "@/components/organisms/feedback/toaster";
import { useNavigate } from "react-router-dom";
import useAddProspectCV from "@/services/admin-services/mutations/useAddProspectCV";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import useUpdateProspectCV from "@/services/admin-services/mutations/useUpdateProspectCv";
import { useTranslation } from "react-i18next";
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import PrintSuccessMessage from "@/components/organisms/feedback/PrintSuccessMessage";
import { Switch } from "@/components/ui/switch";

export default function WaitDocx({ handleReset, template, templateID }) {

    const { requestDOCX, docxFile, loading: loadingDOCX, error: errorDOCX, fileName } = useDocxRequest();

    const [languageForTemplate, setLanguageForTemplate] = useState("FR");
    const [titleForTemplate, setTitleForTemplate] = useState("");
    const [errorForm, setErrorForm] = useState();
    const [anonymous, setAnonymous] = useState(false);
    const navigate = useNavigate();
    const [t] = useTranslation("global");

    const { addNewProspectCV, data: dataAddTemplate, loading: loadingAddTemplate, error: errorAddTemplate } = useAddProspectCV();
    const { updateExistingProspectCV, data: updateData, loading: updateLoading, error: updateError } = useUpdateProspectCV();

    const topEuropeanLanguages = ['GB', 'DE', 'FR', 'IT', 'ES', 'NL'];

    const addNewTemplate = async () => {
        if ((languageForTemplate && titleForTemplate && template)) {
            setErrorForm(false);
            console.log("WaitPdf ", template, languageForTemplate);
            const newTemplateId = await addNewProspectCV(template, languageForTemplate, titleForTemplate);
            if (newTemplateId) {
                toast({
                    variant: "success",
                    title: "success.templateAdded",
                    duration: 1500,
                })
                navigate("../")
            }
        } else {
            setErrorForm(true)
            toast({
                variant: "error",
                title: "error.cantBeNull",
                duration: 8000,
            })
        }


    }
    const updateTemplate = async () => {
        if ((languageForTemplate && titleForTemplate && template)) {
            setErrorForm(false);
            console.log("WaitPdf ", template, languageForTemplate);
            const receivedTemplateId = await updateExistingProspectCV(template, languageForTemplate, titleForTemplate);
            if (receivedTemplateId) {
                toast({
                    variant: "success",
                    title: "success.templateUpdated",
                    duration: 1500,
                })
                navigate("../")
            }
        } else {
            setErrorForm(true)
            toast({
                variant: "error",
                title: "error.cantBeNull",
                duration: 8000,
            })
        }
    }

    return (
        <div className='flex flex-col min-h-[55vh] justify-center items-center py-thirdDegree text-center gap-secondDegree w-full '>
            <Toaster />

            {!docxFile && <div className="flex flex-col gap-thirdDegree items-center my-16">
                <Label size="h4" message="consultants.cv.resumeFeatures"></Label>
                <div className="text-start gap-thirdDegree items-center grid grid-cols-4 w-full">
                    <Label className="col-span-1 items-start" message="consultants.cv.anonymizeResume"></Label>
                    <Switch
                        checked={anonymous}
                        onCheckedChange={(value) => setAnonymous(value)}
                        className="col-span-3"
                    />
                </div>
                <div className=" gap-thirdDegree text-start items-center grid grid-cols-4 w-full">
                    <Label className="  " message="consultants.cv.mainLanguage" />
                    <div className="flex gap-secondDegree items-end col-span-3">
                        <Select onValueChange={setLanguageForTemplate} value={languageForTemplate} >
                            <div className="flex flex-col items-start gap-1 w-full">
                                {/* <Label className="text-primary" message="consultants.cv.mainLanguage" /> */}
                                <SelectTrigger className={`w-full bg-hoverLight ${errorForm && !languageForTemplate && `border-error`}`} >
                                    <SelectValue placeholder={<Label message="global.actions.select" />} />
                                </SelectTrigger>
                            </div>

                            <SelectContent>
                                {Object.keys(countries)
                                    .filter(code => topEuropeanLanguages.includes(code))
                                    .map(code => {
                                        const country = countries[code];
                                        const emoji = getEmojiFlag(code.toUpperCase());
                                        const l = languages[country.languages[0]]?.name
                                        const countryInAppLanguage = t(`global.languages.${l.toLowerCase()}`)
                                        return <SelectItem key={code} value={code == "GB" ? "EN" : code}>{emoji + " " + countryInAppLanguage}</SelectItem>;
                                    })}
                            </SelectContent>
                        </Select>

                    </div>

                </div>
                <Button text="global.actions.generate" onClick={() => { requestDOCX(template, languageForTemplate, anonymous, titleForTemplate) }}></Button>

            </div>}
            {loadingDOCX &&
                <>
                    <Label message="consultants.cv.waitingPdf" />
                    <iframe src="https://lottie.host/embed/4a4bb743-f502-4351-9ed1-71191525c1f5/CpD3cpg3EG.json" className='h-50'></iframe>
                </>
            }
            {errorDOCX && <PrintErrorMessage error={errorDOCX} />}

            <div className="flex gap-thirdDegree w-full items-center ">
                {errorAddTemplate && <PrintErrorMessage error={errorAddTemplate} />}

                {(docxFile && !loadingDOCX && !errorDOCX) &&
                    <div className=" w-1/2 gap-firstDegree   flex flex-col items-center">

                        <div className="border border-success flex  p-firstDegree pb-10 rounded-sm w-full flex-col gap-secondDegree bg-white grow max-w-[400px]" >
                            <PrintSuccessMessage success="success.done" />
                            <Label message="consultants.cv.docxReady" />
                            <a href={docxFile} download={fileName || 'document.docx'}>
                                <Button showLeftIcon leftIcon={<DownloadRoundedIcon />} text="global.actions.download" />
                            </a>
                        </div>
                    </div>}

                {(languageForTemplate && docxFile) &&
                    <div className="flex flex-col gap-thirdDegree items-center bg-lighter p-thirdDegree rounded-sm shadow-md w-min h-min">
                        <Label message="consultants.cv.wantSaveTemplate"></Label>
                        <div className="flex flex-col items-start gap-1 w-full">
                            <Label className="text-primary" message="consultants.cv.titleTemplate" />
                            <Input className={` bg-white ${errorForm && !titleForTemplate && `border-error`}`} onChange={(e) => setTitleForTemplate(e.target.value)} value={titleForTemplate} />
                        </div>
                        <div className="flex gap-secondDegree">
                            {(!loadingAddTemplate && templateID && languageForTemplate && docxFile) && <Button style="outline" text="consultants.cv.edit" onClick={() => updateTemplate()} />}
                            {(loadingAddTemplate) ? <span className="loader"></span> : (languageForTemplate && docxFile && <Button style="" text="consultants.cv.newOne" onClick={() => addNewTemplate()} />)}
                        </div>
                    </div>
                }
            </div>

            <div className=" space-x-4 space-y-4">
                <Button style="ghost" onClick={handleReset} text="global.actions.reStart" className="w-fit" />
                <Button style="outline" onClick={() => { navigate("../") }} text="global.actions.backToMain"></Button>
            </div>



        </div>
    )
}




